import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { abridgedclass, lessondetails, lessonnote, liveclassschedule, moduledetails } from '../models/module/moduledetails';
import { ModuleDetailsComponent } from '../modules/details/details.component';

@Injectable({
  providedIn: 'root'
})
export class ClassmanagementService {
  getattendance(meetingid: any) {
    //meetingid="006c959d-0820-4b47-be84-c043d309632d"

    return this.httpClient.get(this.rootURL + `moduleclass/getattendancefile?meetingid=${meetingid}`, { responseType: 'blob' });
    //return this.httpClient.get(`https://api.vcircle.ng/meeting/getattendancelist?companyid=tsolutions&passcode=alicia&meetingid=${meetingid}`)

  }



  getnextlesson(classid: number, moduleid: number) {
    return this.httpClient.get(this.rootURL + `moduleclass/nextlesson?classid=${classid}&moduleid=${moduleid}`);
  }

  getprevlesson(classid: number, moduleid: number) {
    return this.httpClient.get(this.rootURL + `moduleclass/previouslesson?classid=${classid}&moduleid=${moduleid}`);
  }

  movelessondown(lessonid: number, moduleid: number) {
    return this.httpClient.post(this.rootURL + `moduleclass/movelessondown?classid=${lessonid}&moduleid=${moduleid}`, {});
  }
  movelessonup(lessonid: number, moduleid: number) {
    return this.httpClient.post(this.rootURL + `moduleclass/movelessonup?classid=${lessonid}&moduleid=${moduleid}`, {});
  }
  getClassModuleDetails(classid: number): Observable<moduledetails> {
    return this.httpClient.get<moduledetails>(this.rootURL + `moduleclass/classmoduledetails?classid=${classid}`);
  }
  getClassDetails(classid: number): Observable<lessondetails> {
    return this.httpClient.get<lessondetails>(this.rootURL + `moduleclass/classdetails?classId=${classid}`, { headers: this.req_headers });
  }

  getClassDetailsAbridged(classid: number): Observable<abridgedclass> {
    //debugger;
    return this.httpClient.get<abridgedclass>(this.rootURL + `moduleclass/classdetailsabridged?classId=${classid}`, { headers: this.req_headers });
  }

  getClassNote(classid: number): Observable<Array<lessonnote>> {
    return this.httpClient.get<Array<lessonnote>>(this.rootURL + `moduleclass/classnote?classId=${classid}`, { headers: this.req_headers });
  }
  constructor(private httpClient: HttpClient) { }
  readonly rootURL = environment.ImpataAppAPIRoot;
  readonly userTokenLocalStorageKey = environment.userTokenStore
  readonly currentUserToken: string;
  req_headers = new HttpHeaders({ "content-type": "application/json", "accept": "application/json" });


  addeditclass(lesson: abridgedclass): Observable<abridgedclass> {
    //debugger;
    // let data = {
    //   id: lesson.id,
    //   title: lesson.title,
    //   description: lesson.description,
    //   moduleid: lesson.moduleid,
    //   classposition:lesson.classposition
    // };
    return this.httpClient.post<abridgedclass>(this.rootURL + 'moduleclass/addeditlesson', lesson, { headers: this.req_headers });
  }

  deleteclass(classid: number, moduleid: number) {
    return this.httpClient.delete(this.rootURL + `moduleclass/deleteclass?id=${classid}&moduleid=${moduleid}`, { headers: this.req_headers });
  }

  classhascontent(classid: number) {
    return this.httpClient.get(this.rootURL + `moduleclass/classhascontent?classid=${classid}`, { headers: this.req_headers });
  }

  addeditclassnote(lessonnote: Array<lessonnote>, classid: number) {    
    return this.httpClient.post(this.rootURL + 'moduleclass/addeditclassnote', JSON.stringify(lessonnote), { headers: this.req_headers });
  }

  deleteclassnote(classId: number, noteId: number) {
    return this.httpClient.delete(this.rootURL + `moduleclass/deleteclassnote?classId=${classId}&noteId=${noteId}`);
  }
  
  saveclassfile(moduleid: number, classid: number, files: FileList) {
    let formData = new FormData();
    formData.append('file', files[0], files[0].name);
    return this.httpClient.post(this.rootURL + `moduleclass/uploadclassfilecontent?moduleid=${moduleid}&classid=${classid}`, formData);
  }

  getclassfiles(classId: number) {
    return this.httpClient.get(this.rootURL + `moduleclass/getclassfiles?id=${classId}`);
  }

  deleteclassfile(classId: number, fileId: number) {
    return this.httpClient.delete(this.rootURL + `moduleclass/deleteclassfile?classId=${classId}&fileId=${fileId}`);
  }

  removeclassvideo(classid: number, sno: number) {
    return this.httpClient.delete(this.rootURL + `moduleclass/deleteclassfile?id=${classid}&sno=${sno}`);
  }

  markLessonCompleted(classid: number) {
    return this.httpClient.post(this.rootURL + `moduleclass/marklessoncomplete?classid=${classid}`, {});
  }

  scheduleLiveClass(schedule: liveclassschedule) {
    return this.httpClient.post(this.rootURL + `moduleclass/scheduleliveclass`, schedule, { headers: this.req_headers });
  }

  getLiveClassSchedule(id: number): Observable<liveclassschedule> {
    return this.httpClient.get<liveclassschedule>(this.rootURL + `moduleclass/getliveclassschedule?id=${id}`);
  }

  getLiveClassSchedules(classid: number): Observable<liveclassschedule[]> {
    return this.httpClient.get<liveclassschedule[]>(this.rootURL + `moduleclass/getliveclassschedules?classid=${classid}`);
  }

  getLiveClassAuthToken(scheduleid: number): Observable<any> {
    return this.httpClient.post(this.rootURL + `moduleclass/generateliveclassauthtoken?scheduleid=${scheduleid}`, {});
  }

  deleteliveclassschedule(scheduleid: number) {
    return this.httpClient.post(this.rootURL + `moduleclass/deleteliveclassschedule?id=${scheduleid}`, {});
  }

  importRecordingToMediaLibrary(scheduleid: number) {
    return this.httpClient.post(this.rootURL + `moduleclass/importrecordingfromvcirlce?scheduleid=${scheduleid}`, {});
  }

  checkVCircleRecordingReady(scheduleid: number) {
    return this.httpClient.get(this.rootURL + `moduleclass/checkvcirclerecordingready?scheduleid=${scheduleid}`);
  }

  // checkLessonCompleted(classid: number) {
  //   return this.httpClient.get(this.rootURL + `moduleclass/isclasscompleted?classid=${classid}`);
  // }
  getModuleLessons(moduleid:number){
    return this.httpClient.get(this.rootURL + `moduleclass/getmoduleclasses?moduleid=${moduleid}`);
  }

  logLessonView(moduleid: number, classid: number ){
    return this.httpClient.post(this.rootURL + `moduleclass/loglessonview?moduleid=${moduleid}&classid=${classid}`, { headers: this.req_headers });
  }
}
